import LanguageSwitcher from '@/components/LanguageSwitcher/LanguageSwitcher';
import Link from '@/components/LangLink/LangLink';
import MymDropdown from '@/components/MymDropdown/MymDropdown';
import NavLabel from '@/components/NavLabel/NavLabel';
import { splitTerm } from '@/utils/splitTerm';
import { useNavigationStore } from '@/store/useNavigationStore';

function Drawer({ isOpen, onClose }) {
    const pages = useNavigationStore((s) => s.pages);
    const isReady = useNavigationStore((s) => s.isReady);

    const [huir, vivir, regresar, irse] = useNavigationStore((s) => s.pageGroups);
    const huirPages = pages.filter((page) => page.pageGroup === huir?.section_id);
    const vivirPages = pages.filter((page) => page.pageGroup === vivir?.section_id);
    const regresarPages = pages.filter((page) => page.pageGroup === regresar?.section_id);
    const irsePages = pages.filter((page) => page.pageGroup === irse?.section_id);
    const timelinePage = pages.find((page) => page.type === 'timeline');
    const learnMorePage = pages.find((page) => page.type === 'learnMore');

    return (
        <div id="main-drawer" className={`drawer ${isOpen ? 'open' : ''}`} inert={!isOpen}>
            <LanguageSwitcher className="is-hidden-desktop mb-7" />

            {isReady && (
                <>
                    <p className="has-text-primary">{huir?.title}</p>
                    <ul className="list-reset is-size-4 is-flex is-flex-direction-column gap-5 my-4">
                        {huirPages.map((page) => {
                            const { primary, secondary } = splitTerm(page.term);
                            return (
                                <li key={page.section_id} className="pl-6">
                                    <Link to={page.web_path} className="link-dn" onClick={onClose}>
                                        <NavLabel primary={primary} secondary={secondary} inline />
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                    <p className="has-text-primary">{vivir?.title}</p>
                    <ul className="list-reset is-size-4 is-flex is-flex-direction-column gap-5 my-4">
                        {vivirPages.map((page) => {
                            const { primary, secondary } = splitTerm(page.term);
                            return (
                                <li key={page.section_id} className="pl-6">
                                    <Link to={page.web_path} className="link-dn" onClick={onClose}>
                                        <NavLabel primary={primary} secondary={secondary} inline />
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                    <p className="has-text-primary">{regresar?.title}</p>
                    <ul className="list-reset is-size-4 is-flex is-flex-direction-column gap-5 my-4">
                        {regresarPages.map((page) => {
                            const { primary, secondary } = splitTerm(page.term);
                            return (
                                <li key={page.section_id} className="pl-6">
                                    <Link to={page.web_path} className="link-dn" onClick={onClose}>
                                        <NavLabel primary={primary} secondary={secondary} inline />
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                    <p className="has-text-primary">{irse?.title}</p>
                    <ul className="list-reset is-size-4 is-flex is-flex-direction-column gap-5 my-4">
                        {irsePages.map((page) => {
                            const { primary, secondary } = splitTerm(page.term);
                            return (
                                <li key={page.section_id} className="pl-6">
                                    <Link to={page.web_path} className="link-dn" onClick={onClose}>
                                        <NavLabel primary={primary} secondary={secondary} inline />
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                    <div className="pt-7 flow">
                        <ul className="list-reset is-size-4 is-flex is-flex-direction-column gap-5 my-4">
                            {[timelinePage, learnMorePage].map((page) => {
                                const { primary, secondary } = splitTerm(page.term);
                                return (
                                    <li key={page.section_id}>
                                        <Link
                                            to={page.web_path}
                                            className="link-dn"
                                            onClick={onClose}
                                        >
                                            <NavLabel
                                                primary={primary}
                                                secondary={secondary}
                                                inline
                                            />
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </>
            )}

            <MymDropdown drawer />
        </div>
    );
}

export default Drawer;
